module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "section-dashboard-headbar"
  }, [_c('div', {
    staticClass: "container mt-3 mb-3"
  }, [_c('erco-dashboard-headbar')], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-3 mb-3"
  }, [_c('erco-statusbar')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-faded"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row pt-3 mb-3"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-editbar')], 1)]), _vm._v(" "), (_vm.freshlyCopiedItems.length > 0) ? _c('div', {
    staticClass: "freshly-copied-items-container"
  }, [_c('b', {
    staticClass: "d-block mt-4 mb-4"
  }, [_vm._v("Geklonte / leer kopierte Objekte")]), _vm._v(" "), _c('erco-object-card-overview', {
    attrs: {
      "items": _vm.freshlyCopiedItems,
      "disabledItemRestriction": true
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('erco-object-card-overview', {
    attrs: {
      "items": _vm.notFreshlyCopiedItems,
      "visibleItemsNum": _vm.visibleItemsNum,
      "disabledItemRestriction": _vm.disabledItemRestriction
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('b-alert', {
    staticClass: "info",
    attrs: {
      "show": _vm.filteredItems.length === 0
    }
  }, [(!_vm.itemFiltersActive) ? _c('span', [_vm._v("Keine Objekte gefunden!")]) : _vm._e(), _vm._v(" "), (_vm.itemFiltersActive) ? _c('span', [_vm._v("Keine Objekte unter Berücksichtigung der aktiven Filter gefunden!")]) : _vm._e(), _vm._v(" "), (_vm.searchString.length > 0) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('strong', [_vm._v("Hinweis:")]), _vm._v(" Die Suche ist aktiv")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-fetcher_"
  }, [(!_vm.disabledItemRestriction && _vm.moreItemsAvailable) ? _c('b-button', {
    staticClass: "_button",
    on: {
      "click": _vm.handleItemFetch
    }
  }, [_vm._v("\n\t\t\t\t\tMehr Einträge anzeigen\n\t\t\t\t")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.inProcess) ? _c('erco-cloak', {
    staticClass: "cloak"
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e30c62c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ErcoDashboard.vue
// module id = 676
// module chunks = 0